<template>
    <div class="mt-3" ref="pdfContent">
        <div ref="document">
            <!-- Header -->
            <div class="d-flex justify-content-between align-items-center mb-3 ">
                <div class="col-md-8">
                    <h4>🎯 Target & Goal List</h4>
                </div>
                <div class="col-md-4 text-end no-print">
                    <button class="btn btn-primary" @click="$router.push('/target-form')">
                        + Add
                    </button>
                    <button class="btn btn-primary" @click="getSummary()">
                        Update
                    </button>
                    <button class="btn btn-primary" @click="printPDF" :disabled="targets.length === 0">
                        <i class="fa fa-print"></i> Print
                    </button>
                </div>
            </div>
        </div>

        <!-- 🔍 Filters Section -->
        <div class="card mb-4 shadow-sm border-0 no-print">
            <div class="card-body">
                <div class="row g-3 align-items-end">
                    <div class="col-md-3 position-relative">
                        <label>Employee</label>
                        <input type="text" class="form-control form-cascade-control input-small"
                            v-model="searchEmployee" @input="filterEmployeeList" placeholder="Search Employee"
                            autocomplete="off" />
                        <ul v-if="filteredEmployees.length > 0" class="list-group position-absolute suggestion-box">
                            <li class="list-group-item list-group-item-action" v-for="emp in filteredEmployees"
                                :key="emp.id" @click="selectEmployee(emp)">
                                {{ emp.name }} ({{ emp.generatedid }})
                            </li>
                        </ul>
                    </div>
                    <!-- <div class="col-md-3">
                        <label>Employee</label>
                        <select v-model="filters.userid" class="form-control form-cascade-control input-small">
                            <option value="">All Employees</option>
                            <option v-for="emp in employees" :key="emp.id" :value="emp.id">
                                {{ emp.name }}
                            </option>
                        </select>
                    </div> -->
                    <div class="col-md-3">
                        <label>Month,Year</label>
                        <input type="month" class="form-control form-cascade-control input-small" v-model="filters.date"
                            placeholder="Enter Year" />
                    </div>

                    <!-- <div class="col-md-4">
                        <label >Month</label>
                        <select v-model="filters.month" class="form-control form-cascade-control input-small">
                            <option value="">All Months</option>
                            <option v-for="m in 12" :key="m" :value="m">
                                {{ monthName(m) }}
                            </option>
                        </select>
                    </div>

                    <div class="col-md-3">
                        <label class="form-label fw-bold">Year</label>
                        <input type="number" class="form-control" v-model="filters.year" min="2020"
                            placeholder="Enter Year" />
                    </div> -->

                    <!-- Buttons -->
                    <div class="col-md-2 ">
                        <button class="btn btn-info " @click="fetchTargets">
                            <i class="fa fa-search"></i>
                        </button>
                        <button class="btn btn-secondary ml-5" @click="refresh">
                            <i class="fa fa-refresh"></i>
                        </button>
                    </div>
                </div>
                <hr />
                <div class=" ">
                    <div class=" row">
                        <div class="col-md-3">
                            <div class="small_blog">
                                <label>Total Sale Count : </label>
                                <span class="total">
                                    {{ total_sale_count ?? 0 }}
                                </span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="small_blog">
                                <label>Total Lead Count : </label>
                                <span class="total">
                                    {{ total_lead_count ?? 0 }}
                                </span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="small_blog">
                                <label>Total Visits : </label>
                                <span class="total">
                                    {{ total_visit_count ?? 0 }}
                                </span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="small_blog">
                                <label>Total Deliveries : </label>
                                <span class="total">
                                    {{ total_delivery_count ?? 0 }}
                                </span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="small_blog">
                                <label>Total Social Media Tasks : </label>
                                <span class="total">{{ total_social_media_count }}</span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="small_blog">
                                <label>Total Collection : </label>
                                <span class="total">
                                    {{ total_collection ?? 0 }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>

            <table class="table table-bordered table-striped text-center align-middle">
                <thead class="">
                    <tr>
                        <th rowspan="2">#</th>
                        <th rowspan="2">Employee</th>
                        <th rowspan="2">Month</th>
                        <th rowspan="2">Year</th>
                        <th colspan="6">Target</th>
                        <th colspan="6">Achieved</th>
                        <th rowspan="2">Performance entered<br /><small class="text-muted">(month total)</small></th>
                        <th rowspan="2" class="no-print">Action</th>
                    </tr>
                    <tr class="table-info no-print">
                        <th>Sales</th>
                        <th>Leads</th>
                        <th>Visits</th>
                        <th>Deliveries</th>
                        <th>Social Media Tasks</th>
                        <th>Collection</th>
                        <th>Sales</th>
                        <th>Leads</th>
                        <th>Visits</th>
                        <th>Deliveries</th>
                        <th>Social Media Tasks</th>
                        <th>Collection</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(item, i) in targets" :key="item.id">
                        <td>{{ i + 1 }}</td>
                        <td>{{ item.employee?.name || "N/A" }}</td>
                        <td>{{ monthName(item.month) }}</td>
                        <td>{{ item.year }}</td>
                        <td>{{ item.target_sales }}</td>
                        <td>{{ item.target_leads }}</td>
                        <td>{{ item.target_visits }}</td>
                        <td>{{ item.target_deliveries }}</td>
                        <td>{{ item.target_social_media || 0 }}</td>
                        <td>{{ item.target_collection }}</td>
                        <td>
                            <strong class="fs-17">{{ item.achieved_sales }}</strong>
                            <br />
                            <span>({{ getPercentage(item.achieved_sales, item.target_sales) }}%)</span>
                        </td>
                        <td>
                            <strong class="fs-17">{{ item.achieved_leads }}</strong>
                            <br />
                            <span>({{ getPercentage(item.achieved_leads, item.target_leads) }}%)</span>
                        </td>
                        <td>
                            <strong class="fs-17">{{ item.achieved_visits }}</strong>
                            <br />
                            <span>({{ getPercentage(item.achieved_visits, item.target_visits) }}%)</span>
                        </td>
                        <td>
                            <strong class="fs-17">{{ item.achieved_deliveries }}</strong>
                            <br />
                            <span>({{ getPercentage(item.achieved_deliveries, item.target_deliveries) }}%)</span>
                        </td>
                        <td>
                            <strong class="fs-17">{{ item.achieved_social_media || 0 }}</strong>
                            <br />
                            <span>({{ getSocialMediaPercentage(item.achieved_social_media, item.target_social_media) }}%)</span>
                        </td>
                        <td>
                            <strong class="fs-17">{{ item.achieved_collection }}</strong>
                            <br />
                            <span>({{ getPercentage(item.achieved_collection, item.target_collection) }}%)</span>
                        </td>
                        <!-- <td>
                        <div class="circle" :style="circleProgress(item.achieved_sales, item.target_sales)">
                            <span>{{ getPercentage(item.achieved_sales, item.target_sales) }}%</span>
                        </div>
                        <div><span>{{ item.achieved_sales || 0 }}</span></div>
                    </td>
                    <td>
                        <div class="circle" :style="circleProgress(item.achieved_leads, item.target_leads)">
                            <span>{{ getPercentage(item.achieved_leads, item.target_leads) }}%</span>
                        </div>
                        <div><span>{{ item.achieved_leads || 0 }}</span></div>
                    </td>
                    <td>
                        <div class="circle" :style="circleProgress(item.achieved_collection, item.target_collection)">
                            <span>{{ getPercentage(item.achieved_collection, item.target_collection) }}%</span>
                        </div>
                        <div><span>{{ item.achieved_collection || 0 }}</span></div>
                    </td> -->

                        <td class="text-start performance-cell">
                            <template v-if="item.performance && item.performance.days_entered">
                                <div>Sales: <strong>{{ item.performance.sales_count }}</strong></div>
                                <div>References: <strong>{{ item.performance.reference_count }}</strong></div>
                                <div>Visits: <strong>{{ item.performance.visit_count }}</strong></div>
                                <div>Deliveries: <strong>{{ item.performance.delivery_count }}</strong></div>
                                <div>Social Media Tasks: <strong>{{ item.performance.social_media_count || 0 }}</strong></div>
                                <div>Collection: <strong>₹{{ item.performance.collection_amount }}</strong></div>
                                <small class="text-muted">{{ item.performance.days_entered }} day(s) entered</small>
                            </template>
                            <span v-else class="text-muted">Not entered</span>
                        </td>
                        <td class="no-print">
                            <button class="btn btn-sm btn-warning " @click="edit(item)" title="Edit">
                                <i class="fa fa-edit"></i>
                            </button>
                            <button class="btn btn-sm btn-danger ml-5" @click="remove(item.id)" title="Delete">
                                <i class="fa fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import debounce from "lodash.debounce";
import html2pdf from 'html2pdf.js';

export default {
    data() {
        return {
            targets: [],
            filters: {
                userid: "",
                date: new Date().toISOString().split("T")[0],

            },
            searchEmployee: "",
            filteredEmployees: [],
            total_sale_count: 0,
            total_lead_count: 0,
            total_visit_count: 0,
            total_delivery_count: 0,
            total_social_media_count: 0,
            total_collection: 0
        };
    },
    computed: {
        ...mapGetters(["employees"]),
    },
    watch: {
        employees() {
            if (this.employees.length > 0) this.refresh();
        },
    },
    async mounted() {
        if (this.employees?.length == 0) {
            await this.$store.dispatch("fetchemployees");
        } else {
            this.refresh();
        }
    },
    methods: {
        refresh() {
            this.filters.userid = "";
            this.searchEmployee = "";
            this.filteredEmployees = [];
            this.filters.date = new Date().toISOString().split("T")[0];
            this.fetchTargets();
        },
        async fetchTargets() {
            let param = {
                userid: this.filters.userid,
                month: this.filters.date.split("-")[1],
                year: this.filters.date.split("-")[0],

            }
            const { data } = await axios.post("/api/target/fetchbyadmin", param);
            this.targets = data.data;
            this.total_sale_count = this.targets.reduce((a, b) => a + parseFloat(b.achieved_sales), 0);
            this.total_lead_count = this.targets.reduce((a, b) => a + parseFloat(b.achieved_leads), 0);
            this.total_visit_count = this.targets.reduce((a, b) => a + parseFloat(b.achieved_visits), 0);
            this.total_delivery_count = this.targets.reduce((a, b) => a + parseFloat(b.achieved_deliveries || 0), 0);
            this.total_social_media_count = this.targets.reduce((a, b) => a + Number(b.achieved_social_media || 0), 0);
            this.total_collection = this.targets.reduce((a, b) => a + parseFloat(b.achieved_collection), 0);
        },
        async remove(id) {
            if (!confirm("Are you sure you want to delete this target?")) return;
            await axios.post(`/api/target/delete/${id}`);
            this.refresh();
        },
        edit(item) {
            this.$router.push({ path: "/target-form", query: { id: item.id } });
        },
        async getSummary() {
            if (!this.filters.date) {
                alert("Please select a month.");
                return;
            }
            const { data } = await axios.post("/api/cron/hourly/target/getsummary", {
                // userid: this.filters.userid,
                month: this.filters.date.split("-")[1],
                year: this.filters.date.split("-")[0],
            });
            alert(data.message);
            this.refresh();
        },
        monthName(m) {
            return new Date(0, m - 1).toLocaleString("default", { month: "long" });
        },
        circleProgress(achieved, target) {
            achieved = parseFloat(achieved) || 0;
            target = parseFloat(target) || 1; // avoid division by zero

            const percent = (achieved / target) * 100;

            // ✅ If progress is 75% or more → Green
            // if (percent >= 75) {
            //     return {
            //         background: `conic-gradient(green ${percent}%, #e9ecef ${percent}%)`,
            //         color: "#fff",
            //         fontWeight: "bold"
            //     };
            // }

            // 🔵 Default circular progress
            return {
                background: `conic-gradient(#007bff ${percent}%, #e9ecef ${percent}%)`,
                fontWeight: "bold",
                color: "#000"
            };
        },
        getPercentage(achieved, target) {
            achieved = parseFloat(achieved) || 0;
            target = parseFloat(target) || 1; // avoid division by zero

            const percent = (achieved / target) * 100;
            return percent.toFixed(2);
        },
        getSocialMediaPercentage(achieved, target) {
            const goal = Number(target || 0);
            return goal > 0 ? ((Number(achieved || 0) / goal) * 100).toFixed(2) : '0.00';
        },
        filterEmployeeList: debounce(async function () {
            if (this.searchEmployee == "") {
                this.filters.userid = 0
                this.filteredEmployees = [];
                return;
            }
            try {
                const response = await axios.post('api/vsdigi/users/fetch', {
                    isemployee: 1, active: 0, columns: 'id,name,isadvisor,generatedid,companyid',
                    search: this.searchEmployee, noofrec: 50, isdisabled: 0
                })
                this.filteredEmployees = response.data;
            } catch (error) {
                console.error(error);
            }
        }, 1000),

        selectEmployee(emp) {
            this.searchEmployee = emp.name;
            this.filters.userid = emp.id;
            this.filteredEmployees = []; // ✅ hide list after selection
        },
        printPDF() {
            if (this.targets.length === 0) {
                alert("No data to print.");
                return;
            }

            const content = this.$refs.pdfContent;

            // Temporarily add a style block for PDF customization
            const style = document.createElement('style');
            style.innerHTML = `
                body {
                    font-family: 'Helvetica', 'Arial', sans-serif;
                }
                .pdf-header {
                    text-align: center;
                    margin-bottom: 5px;
                }
                .pdf-header h2 {
                    font-size: 22px;
                    font-weight: bold;
                    margin-bottom: 5px;
                }
                .pdf-header p {
                    font-size: 12px;
                    color: #555;
                }
                .table {
                    font-size: 9px; /* Custom font size for PDF table */
                    width: 100%;
                    border-collapse: collapse; /* Important for PDF rendering */
                }
                .table th, .table td {
                    padding: 4px 2px; /* Reduced padding for more content */
                    word-wrap: break-word;
                }
                .no-print {
                    display: none; /* Hide elements with this class in the PDF */
                }
                table {
                    width: 100% !important;
                    border-collapse: collapse !important;
                    table-layout: fixed !important;
                    font-size: 12px !important;
                }
                    .table th {
                        font-size: 14px !important;
                    }

                .table strong {
                    font-size: 12px !important;
                }
                th, td {
                    padding: 3px !important;
                    word-break: break-word !important;
                }

                tr {
                    page-break-inside: avoid !important;
                }

                .no-print {
                    display: none !important;
                }
                
                    
            `;
            content.prepend(style); // Prepend to ensure styles are applied first

            const options = {
                margin: [0.5, 0.4, 0.5, 0.4], // top, left, bottom, right in inches
                filename: `TargetGoal-${this.filters.date}.pdf`,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' } // Changed to landscape

            };

            html2pdf().from(content).set(options).save().then(() => {
                // Clean up the added style element after PDF is generated
                content.removeChild(style);
            });
        }
    },
};
</script>

<style scoped>
.performance-cell {
    white-space: nowrap;
    font-size: 12px;
}
.card {
    border-radius: 10px;
}

.table {
    font-size: 14px;
}

.table th,
.table td {
    vertical-align: middle;
}

.form-label {
    font-weight: 600;
}

.fs-17 {
    font-size: 17px;
}

.list-group-item {
    padding: 0.5rem;
    font-size: 14px;
}

/* This style will be applied when printing from the browser (File > Print) */
@media print {
    .no-print {
        display: none;
    }
}

.pdf-header {
    display: none;
}

/* Hide PDF header on the webpage */
</style>
